var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Breadcrumb", { attrs: { dataSource: _vm.breadcrumbList } }),
      _c(
        "div",
        { staticClass: "page-container", staticStyle: { "padding-top": "0" } },
        [
          _c(
            "a-tabs",
            {
              attrs: { "default-active-key": _vm.tabKey },
              on: { change: _vm.handleTabChange },
            },
            _vm._l(_vm.tabPaneConfig, function (item) {
              return _c(
                "a-tab-pane",
                { key: item.key, attrs: { tab: item.tab } },
                [
                  _c(
                    "div",
                    { staticClass: "query-area" },
                    [
                      _c("j-dict-select-tag", {
                        staticStyle: { width: "150px", "margin-right": "15px" },
                        attrs: {
                          placeholder: "请选择年级",
                          dictCode:
                            "school_grade,grade_name,id,0=delete_flag order by sort_order",
                          isShowEmpty: false,
                        },
                        on: {
                          select: function ($event) {
                            return _vm.$set(
                              _vm.queryParam,
                              "classId",
                              undefined
                            )
                          },
                        },
                        model: {
                          value: _vm.queryParam.gradeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "gradeId", $$v)
                          },
                          expression: "queryParam.gradeId",
                        },
                      }),
                      _c("j-dict-select-tag", {
                        staticStyle: { width: "150px", "margin-right": "15px" },
                        attrs: {
                          placeholder: "请选择班级",
                          dictCode:
                            "school_class,name,id,grade_id=" +
                            (!_vm.queryParam.gradeId
                              ? -1
                              : _vm.queryParam.gradeId),
                          async: true,
                          disabled: !_vm.queryParam.gradeId,
                          isShowEmpty: false,
                        },
                        model: {
                          value: _vm.queryParam.classId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "classId", $$v)
                          },
                          expression: "queryParam.classId",
                        },
                      }),
                      _c("j-dict-select-tag", {
                        staticClass: "search-space",
                        staticStyle: { width: "150px" },
                        attrs: {
                          placeholder: "请选择关爱等级",
                          dictCode: "care_list",
                          isShowEmpty: false,
                        },
                        model: {
                          value: _vm.queryParam.care,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "care", $$v)
                          },
                          expression: "queryParam.care",
                        },
                      }),
                      _c("a-select", {
                        staticStyle: { width: "150px", "margin-right": "15px" },
                        attrs: {
                          placeholder: "请选择处理状态",
                          options: _vm.handleOpts,
                          allowClear: "",
                        },
                        model: {
                          value: _vm.queryParam.warnStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "warnStatus", $$v)
                          },
                          expression: "queryParam.warnStatus",
                        },
                      }),
                      _c("a-select", {
                        staticStyle: { width: "150px", "margin-right": "15px" },
                        attrs: {
                          placeholder: "是否连续提醒",
                          options: _vm.reminderOpts,
                          allowClear: "",
                        },
                        model: {
                          value: _vm.queryParam.continuousFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "continuousFlag", $$v)
                          },
                          expression: "queryParam.continuousFlag",
                        },
                      }),
                      _c("j-dict-select-tag", {
                        staticClass: "search-space",
                        staticStyle: { width: "150px" },
                        attrs: {
                          placeholder: "请选择提醒原因",
                          dictCode: "reminder_reason",
                          isShowEmpty: false,
                        },
                        model: {
                          value: _vm.reasonKey,
                          callback: function ($$v) {
                            _vm.reasonKey = $$v
                          },
                          expression: "reasonKey",
                        },
                      }),
                      _c("a-range-picker", {
                        staticClass: "search-space",
                        staticStyle: { width: "220px" },
                        on: { change: _vm.changeDateRange },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                      _c("a-input-search", {
                        staticClass: "search-space",
                        staticStyle: { width: "150px" },
                        attrs: { placeholder: "请输入学生名字" },
                        on: { change: _vm.searchName },
                        model: {
                          value: _vm.queryParam.studentName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "studentName", $$v)
                          },
                          expression: "queryParam.studentName",
                        },
                      }),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.queryTable },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "15px" },
                          attrs: { type: "primary", icon: "reload" },
                          on: { click: _vm.searchReset },
                        },
                        [_vm._v("\n            重置\n          ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-align-end" },
                    [
                      _vm.identityId == 1
                        ? _c(
                            "a-popconfirm",
                            {
                              attrs: {
                                title: "确定要一键提醒班主任吗？",
                                "ok-text": "确认",
                                "cancel-text": "取消",
                              },
                              on: { confirm: _vm.oneKeyUrgeDo },
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-right": "15px" },
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.btnLoading,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              一键提醒班主任\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            icon: "download",
                            loading: _vm.exportXlsLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleExportXls(item.tab)
                            },
                          },
                        },
                        [_vm._v("\n            导出\n          ")]
                      ),
                    ],
                    1
                  ),
                  _c("TableList", {
                    staticStyle: { "min-height": "350px" },
                    attrs: {
                      columns: _vm.columns,
                      tableData: _vm.dataSource,
                      bordered: "",
                      loading: _vm.loading,
                      scroll: {},
                      pagination: _vm.ipagination,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "labelsList",
                          fn: function ({ record }) {
                            return _c(
                              "div",
                              { staticClass: "flex-align-center" },
                              _vm._l(record.labelsList, function (item, index) {
                                return _c(
                                  "span",
                                  {
                                    key: index,
                                    staticClass: "label-item",
                                    style: {
                                      color: _vm.getStuTagColorConfig(item.key)
                                        .color,
                                      background: _vm.getStuTagColorConfig(
                                        item.key
                                      ).bgColor,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.text) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          },
                        },
                        {
                          key: "weekRemind",
                          fn: function ({ record }) {
                            return _c("span", {}, [
                              record.weekRemind == "1"
                                ? _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                    },
                                    attrs: {
                                      src: require("@/assets/imgs/commonPage/remind.png"),
                                      alt: "",
                                    },
                                  })
                                : _c("span", [_vm._v("未提醒")]),
                            ])
                          },
                        },
                        {
                          key: "action",
                          fn: function ({ record }) {
                            return [
                              _c("div", { staticClass: "action-detail" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "action-span",
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewArchives(record)
                                      },
                                    },
                                  },
                                  [_vm._v("查看档案")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "action-span",
                                    on: {
                                      click: function ($event) {
                                        return _vm.addLedger(record)
                                      },
                                    },
                                  },
                                  [_vm._v("添加台账")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "action-span",
                                    on: {
                                      click: function ($event) {
                                        return _vm.addVisitRecord(record)
                                      },
                                    },
                                  },
                                  [_vm._v("添加家访记录")]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("AddLedgerModal", {
        ref: "addLedgerModalRef",
        on: { refreshData: _vm.loadData },
      }),
      _c("AddVisitRecordModal", {
        ref: "visitRecordModalRef",
        on: { refreshData: _vm.loadData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }